import { render, staticRenderFns } from "./MainMatchStatsPlayer.vue?vue&type=template&id=ac1436c6&scoped=true&"
import script from "./MainMatchStatsPlayer.vue?vue&type=script&lang=js&"
export * from "./MainMatchStatsPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MainMatchStatsPlayer.vue?vue&type=style&index=0&id=ac1436c6&prod&lang=css&"
import style1 from "./MainMatchStatsPlayer.vue?vue&type=style&index=1&id=ac1436c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1436c6",
  null
  
)

export default component.exports